import React from 'react';

import styles from './Title.module.scss';

export default function Title({ title, className }) {
	return <p className={`${styles.title} ${className}`}>{title}</p>;
}
